import React from 'react';

interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon, action }) => (
  <div className="ds-empty">
    {icon && <div className="ds-empty__icon">{icon}</div>}
    <div className="ds-empty__title">{title}</div>
    {description && <div className="ds-empty__description">{description}</div>}
    {action && <div className="ds-empty__action">{action}</div>}
  </div>
);

export default EmptyState;
